
export enum RemoteFeatureFlags
{
	WriteEncounterNote = "save_encounter_note",
	SaveDocumentToChart = "save_document_to_demographic"
}
